module.exports = __webpack_public_path__ + "static/media/Багиров Ш.Г. (НУ).8d07af3a.pdf";